import React from 'react'
import PropTypes from 'prop-types'
import EventTags from './EventCard/EventTags'

const EventTicketHeader = ({ progress, event }) => (
  <div
    className="relative w-full rounded-xl overflow-hidden mb-2.5 py-6 px-5 bg-cover bg-center text-white md:px-9"
    style={{
      backgroundImage: `url(${event.image})`,
    }}
  >
    <div
      className="absolute w-full h-full inset-0"
      style={{
        background: 'linear-gradient(195.07deg, rgba(16, 19, 22, 0.0001) 21.21%, #101316 99.7%)',
      }}
    />
    <div className="relative">
      <EventTags location={event.location} tagsByType={event.tagsByType} />
      <div className="font-ownersWide text-xl w-60 mt-2">{event.title}</div>
    </div>
    {!!progress && (
      <div
        className="absolute bottom-0 left-0 h-1 bg-monaLisaPink transition-width ease-in-out duration-500 "
        style={{ width: `${progress}%` }}
      />
    )}
  </div>
)

EventTicketHeader.propTypes = {
  progress: PropTypes.number,
  event: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    status: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
    tagsByType: PropTypes.object,
  }),
}

export default EventTicketHeader
